import React from 'react';
import { Reveal } from './ui/Reveal';
const items = [{
  title: 'La Herradura Dorada',
  text: 'Sesión privada 1:1 de 45 minutos.'
}, {
  title: 'Mirada personalizada',
  text: 'Un espacio para observar tu situación actual y aquello que hoy necesita mayor atención.'
}, {
  title: 'Hoja de ruta',
  text: 'Claridad sobre los próximos pasos que puedes comenzar a trabajar.'
}, {
  title: 'Guía de Reconexión Energética',
  text: 'Una guía práctica para continuar tu proceso después de nuestra sesión.'
}];
export function IncludesSection() {
  return <section className="bg-ivory px-6 py-20 sm:py-28" data-id="element-162" data-mp="1q05b2lz7ye6e">
      <div className="mx-auto max-w-4xl" data-id="element-163" data-mp="1q0x53sd643uk">
        <Reveal data-id="element-164" data-mp="1l23se25pggvg">
          <h2 className="text-center font-serif text-[1.75rem] font-light leading-tight text-ink sm:text-4xl" data-id="element-165" data-mp="1l2lyrrm30bh3">
            Tu experiencia <em className="not-italic text-gold-dark" data-id="element-166" data-mp="3ke6bvcebxb94">incluye</em>
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 sm:gap-6" data-id="element-167" data-mp="3fg4qgktfkzuh">
          {items.map((item, i) => <li key={item.title} className="flex" data-id="element-168" data-mp="3ufgvdejbghsg" data-mpi={i}>
              <Reveal delay={i * 0.08} className="flex w-full" data-id="element-169" data-mp="2dhenf85n3j9">
                <article className="flex w-full flex-col rounded-[1.5rem] border border-gold/30 bg-cream p-8 shadow-soft" data-id="element-170" data-mp="2amsnj9htanq">
                  <span className="font-serif text-2xl text-gold" aria-hidden="true" data-id="element-171" data-mp="3phfcatlw4igz">
                    ✦
                  </span>
                  <h3 className="mt-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-gold-dark" data-id="element-172" data-mp="m0p3y82u5tc4">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-[16.5px] leading-relaxed text-ink-soft" data-id="element-173" data-mp="7bsnbmmpr7zw">
                    {item.text}
                  </p>
                </article>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}